import {FC} from 'react'
import {AdminFranchise} from '../../../core/_models'

type Props = {
  franchise: AdminFranchise
}

const NameCell: FC<Props> = ({franchise}) => <span>{franchise.name}</span>

export {NameCell}
